import React, { useEffect, useState } from "react";
import { UiNavBar } from "../../_uiComponents/UiNavbar";
import { UiDashboardWrapper } from "../../_uiComponents/UiDashboardWrapper";
import { UiSideBar } from "../../_uiComponents/UiSidebar";
import { UiDashboardContent } from "../../_uiComponents/UiDashboardContent";
import { UiNotificationCard } from "../../_uiComponents/common/UiNotificationCard";
import { CloseIcon } from "../../../styles/img/svg/CloseIcon";
import { UiNotificationCardWrapper } from "../../_uiComponents/UiNotificationCardWrapper";
import { useDispatch, useSelector } from "react-redux";
import {
  dashboardBannerListRequest,
  dashboardSecureMailNotificationClear,
  dashboardSecureMailNotificationRequest,
} from "../../../_redux/_actions/dashboard.actions";
import { BannerSlider } from "./BannerSlider";
import { OptionBoxes } from "./OptionBoxes";
import { FavoritesList } from "./FavoritesList";
import { UiWhiteCard } from "../../_uiComponents/common/UiWhiteCard";
import { Grid } from "@mui/material";
import { UiTextIconButton } from "../../_uiComponents/common/UiButton";
import { BookmarkIcon } from "../../../styles/img/svg/BookmarkIcon";
import { UiFavouriteBillCard } from "../../_uiComponents/UiFavouriteBillCard";

import DialogLogo from "../../../styles/img/dialog-logo.png";
import { useTranslation } from "react-i18next";
import { UiSearchForm } from "../../_uiComponents/Forms/UiSearchForm";
import { UiGrayBgLoader } from "../../_uiComponents/common/UiGrayBgLoader";
import { useLocation, useNavigate } from "react-router-dom";
import {
  commonConstants,
  favouritesConstants,
} from "../../../_redux/_constants";
import {
  setFavouriteScreenType,
  setIsPaginatingFavourites,
  setSelectedFavourite,
  setSelectedNavigationPathName,
} from "../../../_redux/_actions/favourites.actions";
import {
  clearGeneralBiller,
  secureMailMessageClosedRequest,
} from "../../../_redux/_actions";
import { UiDashboardEmptyMessage } from "../../_uiComponents/ErrorMessages/UiEmptyScreens";
import emptyscreenDashboard from "../../../styles/img/empty-accounts-db.png";
import ReadIcon from "../../../styles/img/readIcon.png";

import emptyscreenFavourite from "../../../styles/img/empty-screen-favourite.png";
import { showCustomLoading } from "../../../_helpers/support.services";
import InfiniteScroll from "react-infinite-scroll-component";
import { DateFormatterWithTime } from "../../../_helpers/dateFormatter";
import { EnvelopCircleIcon } from "../../../styles/img/svg/EnvelopCircleIcon";

const ContentLayout = (props) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const navigate = useNavigate();
  const { lang } = useSelector((state) => {
    return {
      lang: state.lang,
    };
  });

  const loader = useSelector((state) => state.loading);
  const { bannersList, secureMailUnread } = useSelector((state) => ({
    bannersList: state.dashboard?.bannersList,
    secureMailUnread:
      (state.dashboard?.secureMailNotification?.length ?? 0) > 0
        ? state.dashboard.secureMailNotification[0]
        : null,
  }));

  const actionDispatch = useDispatch();

  const hideSecureMailToast = () => {
    const secureMailMessageId =
      secureMailUnread?.secureMailMessageId ||
      secureMailUnread?.secureMailMessage?.secureMailMessageId;

    if (secureMailMessageId) {
      actionDispatch(
        secureMailMessageClosedRequest({
          secureMailMessageId,
        }),
      );
    }
  };

  useEffect(() => {
    if (!lang?.defaultLang) return;

    let bannerListPayload = {
      locale: lang.defaultLang,
    };

    if (location?.pathname == "/app/dashboard") {
      actionDispatch(dashboardSecureMailNotificationRequest({}));
    }

    actionDispatch(dashboardBannerListRequest(bannerListPayload));
  }, [lang?.defaultLang]);

  const handleAllFavourites = () => {
    navigate("/app/favourites");
  };
  const favouritesTitle = () => {
    if (!props?.isFavourites || !props?.sectionType) return "";

    switch (props.sectionType) {
      case commonConstants.FAVOURITE_TYPE_BILLER:
        return t("Biller Favourites");
      case commonConstants.FAVOURITE_TYPE_FUND_TRANSFTER:
        return t("Payee Favourites");
      default:
        return "";
    }
  };

  const toBillPay = (data) => {
    actionDispatch(setSelectedFavourite(data));
    actionDispatch(
      setFavouriteScreenType(commonConstants.FAVOURITE_FORM_TYPE_SCREEN),
    );
    actionDispatch(setSelectedNavigationPathName(window.location.pathname));
    actionDispatch(clearGeneralBiller());
    navigate("/app/favourites");
  };

  const renderEmptyMessage = () => {
    if (props?.name && props.name.trim() !== "") {
      return (
        <UiDashboardEmptyMessage
          icon={emptyscreenDashboard}
          className="df-fs-empt df-empt-msg-acc"
        >
          <h3>{t("Uh-oh!")}</h3>
          <p>{t("No results found for your search criteria.")}</p>
        </UiDashboardEmptyMessage>
      );
    } else {
      return (
        <UiDashboardEmptyMessage
          icon={emptyscreenFavourite}
          className="df-fs-fav df-pw-60"
          message={t("Your recent favourites will show up here.")}
        ></UiDashboardEmptyMessage>
      );
    }
  };

  return (
    <>
      <UiDashboardWrapper>
        <UiSideBar />
        <UiDashboardContent>
          {props.children}

          {/* TODO: this is still not implemented */}

          <div
            className={`df-db-right mb-90 ${
              props?.name && props?.name.trim() !== ""
                ? ""
                : "df-bill-payments-right-empty"
            }`}
          >
            {props?.isFavourites && props.isFavourites ? (
              <UiWhiteCard className="df-play-again mt-0">
                <Grid container className="">
                  <Grid size={7}>
                    <h2 className="df-play-again__title">
                      {favouritesTitle()}
                    </h2>
                  </Grid>
                  <Grid size={5} className="text-right">
                    {(props?.name?.trim() ||
                      (Array.isArray(props?.favouriteItems) &&
                        props?.favouriteItems.length > 0)) && (
                      <UiTextIconButton
                        onClick={() => handleAllFavourites()}
                        icon={<BookmarkIcon />}
                        name={t("All Favourites")}
                        className="df-primary-underlined-text-icon-btn"
                      />
                    )}
                  </Grid>
                  <Grid size={12}>
                    {(props?.name?.trim() ||
                      (Array.isArray(props?.favouriteItems) &&
                        props?.favouriteItems.length > 0)) && (
                      <UiSearchForm handleNameChange={props?.setName} />
                    )}
                  </Grid>
                </Grid>

                {props?.favouriteItems && props?.favouriteItems.length === 0 ? (
                  <>
                    {!showCustomLoading(
                      [favouritesConstants.GET_FAVOURITES_LIST_REQUEST],
                      loader?.pendingRequests,
                    ) ? (
                      <>
                        {(!props?.name || props?.name.trim() === "") &&
                        props?.favouriteItems.length === 0 ? (
                          renderEmptyMessage()
                        ) : (
                          <UiDashboardEmptyMessage
                            icon={emptyscreenDashboard}
                            className="df-fs-empt df-empt-msg-acc"
                          >
                            <h3>{t("Uh-oh!")}</h3>
                            <p>
                              {t("No results found for your search criteria.")}
                            </p>
                          </UiDashboardEmptyMessage>
                        )}
                      </>
                    ) : (
                      <UiGrayBgLoader className="df-ch-330" />
                    )}
                  </>
                ) : (
                  <>
                    <InfiniteScroll
                      dataLength={props.favouriteItems.length}
                      next={() => {
                        let nextStart = props?.pageEnd + 1;
                        let nextEnd =
                          props?.pageEnd +
                          commonConstants.FAVOURIT_LIST_PAGE_END;
                        props?.setPageStart(nextStart);
                        props?.setPageEnd(nextEnd);
                        actionDispatch(setIsPaginatingFavourites(true));
                      }}
                      hasMore={props.favouriteItems.length >= props.pageEnd}
                      scrollableTarget="favourite-scroll-container"
                      loader={<h3 className="text-center"></h3>}
                      endMessage={<p className="text-center"></p>}
                    >
                      {props.favouriteItems.map((data, index) => (
                        <UiFavouriteBillCard
                          key={index}
                          logo={
                            (data?.bankUrl || data?.payeeTypeLogo) &&
                            process.env.NFS_PUBLIC_IMAGE_URL +
                              (data?.transactionTypeName ===
                              commonConstants.FAVOURITE_TYPE_FUND_TRANSFTER
                                ? data?.bankUrl
                                : data?.payeeTypeLogo)
                          }
                          title={data.nickname}
                          description={data.accountNumber}
                          handleOnclick={() => toBillPay(data)}
                        />
                      ))}
                    </InfiniteScroll>
                  </>
                )}
              </UiWhiteCard>
            ) : (
              <>
                {/* for the time been we have been asked to hide but not to remove it */}
                {secureMailUnread && (
                  <UiNotificationCardWrapper
                    icon={<CloseIcon />}
                    title={t("You have mail")}
                    name={t("See Details")}
                    seeDetailsLink={() => {
                      navigate(
                        "/app/secure-mail/" + secureMailUnread?.secureMailId,
                      );
                    }}
                    className="mt-0 df-hide-mobile"
                    closeBtnFunc={() => {
                      hideSecureMailToast();
                    }}
                  >
                    <UiNotificationCard
                      icon={ReadIcon}
                      title={secureMailUnread?.subject}
                      message={secureMailUnread?.messageText}
                      date={DateFormatterWithTime(secureMailUnread?.dateTime)}
                    />
                  </UiNotificationCardWrapper>
                )}

                <OptionBoxes />

                <BannerSlider bannersList={bannersList} />

                <FavoritesList />
              </>
            )}
          </div>
        </UiDashboardContent>
      </UiDashboardWrapper>
    </>
  );
};

export default ContentLayout;
